import { render, staticRenderFns } from "./contentHeader-small.vue?vue&type=template&id=11034028&lang=pug&"
import script from "./contentHeader-small.vue?vue&type=script&lang=js&"
export * from "./contentHeader-small.vue?vue&type=script&lang=js&"
import style0 from "./contentHeader-small.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports